import React, { useState } from "react";
import { Input } from "../../ui/Input";
import { Select } from "../../ui/Select";
import { RadioGroup } from "../../ui/RadioGroup";

const buttonStyles = {
  save: {
    padding: "8px 16px",
    borderRadius: "4px",
    border: "none",
    background: "#07b1b0",
    color: "#fff",
    cursor: "pointer",
  },
  cancel: {
    padding: "8px 16px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    background: "#fff",
    color: "#333",
    cursor: "pointer",
  },
};

const buttonContainerStyle = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "10px",
  padding: "10px",
  marginTop: "10px",
};

const AddCustomerForm = ({ formData, isEdit, onChange, onSubmit, onCancel, disabled, subscriptionOptions}) => {
    const [domainError, setDomainError] = React.useState("");

  const handleDomainChange = (e) => {
    const { name, value } = e.target;
    onChange(e); // Keep your original onChange logic

    // Validation logic
    if (value.length < 6) {
      setDomainError("Domain must be at least 6 characters long.");
    } else if (!value.startsWith("@")) {
      setDomainError("Domain must start with '@'.");
    } else if (!/^@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
      setDomainError("Enter a valid domain (e.g. @example.com).");
    } else {
      setDomainError(""); // Valid
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (domainError) return; // Block form submit if invalid
    onSubmit(e);
  };
    return (
        <form style={{ width: "100%" }}>
           
            
            <h4 style={{color: "#07b1b0", margin:"0", marginBottom:"20px"}}>Company Details</h4>
            <Input
                label="Company Name"
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={onChange}
                disabled={disabled}
                required
            />
            <hr />
            <h4 >Company Address</h4>
            <Input
                label="Address Line 1 "
                type="text"
                name="address1"
                value={formData.address1}
                onChange={onChange}
                disabled={disabled}
            />
            <Input
                label="Address Line 2 "
                type="text"
                name="address2"
                value={formData.address2}
                onChange={onChange}
                disabled={disabled}
            />
            <Input
                label="Address Line 3"
                type="text"
                name="address3"
                value={formData.address3}
                onChange={onChange}
                disabled={disabled}
            />
            <Input
                label="City"
                type="text"
                name="city"
                value={formData.city}
                onChange={onChange}
                disabled={disabled}
            />
            <Input
                label="Postcode"
                type="text"
                name="postCode"
                value={formData.postCode}
                onChange={onChange}
                disabled={disabled}
            />
            <Input
                label="State/Province "
                type="text"
                name="state"
                value={formData.state}
                onChange={onChange}
                disabled={disabled}
            />
            <Input
                label="Country"
                type="text"
                name="country"
                value={formData.country}
                onChange={onChange}
                disabled={disabled}
            />
            <hr />
            <h4 style={{color: "#07b1b0"}}>Admin User</h4>
            <Input
                label="Username"
                type="text"
                name="adminUsername"
                value={formData.adminUsername}
                onChange={onChange}
                disabled={disabled}
                required
            />
            <Input
                label="Email Address"
                type="text"
                name="adminEmailAddress"
                value={formData.adminEmailAddress}
                onChange={onChange}
                disabled={disabled}
                required
            />
            <Input
        label="Company Domain"
        type="text"
        name="companyDomain"
        value={formData.companyDomain}
        onChange={handleDomainChange}
        disabled={disabled}
        title="Enter domain e.g. @example.com"
        required
      />
      {domainError && (
        <div style={{ color: "red", fontSize: "12px", marginTop: "8px", marginBottom: "10px" }}>
          {domainError}
        </div>
      )}
            <h4 style={{color: "#07b1b0"}}>Subscription Plan</h4>
            <Select
                label="Subscription Plan"
                name="subscriptionPlan"
                value={formData.subscriptionPlan}
                onChange={onChange}
                options={subscriptionOptions}
                disabled={disabled}
            />
            <Input
                label="Renews "
                type="date"
                name="subscriptionRenew"
                value={formData.subscriptionRenew}
                onChange={onChange}
                disabled={disabled}
            />
            <h4 style={{color: "#07b1b0"}}>Company Preferences</h4>

            <RadioGroup
                label="Enable AI Search"
                name="aiSearch"
                value={formData.aiSearch}
                options={[
                    { value: true, display_value: "Yes" },
                    { value: false, display_value: "No" }
                ]}
                onChange={(e) => onChange({ target: { name: "aiSearch", value: e.target.value === "true" } })}
                disabled={disabled}
            />

            <Input
                label="Logo URL "
                type="text"
                name="url"
                value={formData.url}
                onChange={onChange}
                disabled={disabled}
            />
            <Input
                label="Primary Colour "
                type="text"
                name="primaryColor"
                value={formData.primaryColor}
                onChange={onChange}
                disabled={disabled}
            />
            <Input
                label="Secondary Colour "
                type="text"
                name="secondaryColor"
                value={formData.secondaryColor}
                onChange={onChange}
                disabled={disabled}
            />
            <Input
                label="Tertiary Colour "
                type="text"
                name="tertiaryColor"
                value={formData.tertiaryColor}
                onChange={onChange}
                disabled={disabled}
            />
            <div style={buttonContainerStyle}>
                <button type="submit" style={buttonStyles.save} onClick={onSubmit}>
                    {isEdit ? "Update" : "Save"}
                </button>
                <button type="button" onClick={onCancel} style={buttonStyles.cancel}>
                    Cancel
                </button>
            </div>
        </form>
    );
};

export default AddCustomerForm;